module.exports = __webpack_public_path__ + "img/ios-add-to-homescreen.b1f10158.svg";